export const MAIN_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';